import React from "react";

const Icon = ({ name, size = 20, stroke = 1.5, ...rest }) => {
  const props = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...rest
  };
  switch (name) {
    case "arrow-right":     return (<svg {...props}><path d="M5 12h14"/><path d="m13 5 7 7-7 7"/></svg>);
    case "arrow-up-right":  return (<svg {...props}><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>);
    case "check":           return (<svg {...props}><path d="M20 6 9 17l-5-5"/></svg>);
    case "minus":           return (<svg {...props}><path d="M5 12h14"/></svg>);
    case "plus":            return (<svg {...props}><path d="M12 5v14M5 12h14"/></svg>);
    case "menu":            return (<svg {...props}><path d="M4 7h16M4 12h16M4 17h16"/></svg>);
    case "close":           return (<svg {...props}><path d="M6 6 18 18M18 6 6 18"/></svg>);
    case "star":            return (<svg {...props}><path d="m12 17.3-6.18 3.7 1.64-7.03L2 9.24l7.19-.61L12 2l2.81 6.63 7.19.61-5.46 4.73 1.64 7.03z"/></svg>);
    case "qr":              return (<svg {...props}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3M21 14v3M14 19v2M17 21h4M21 17v0"/></svg>);
    case "menu-card":       return (<svg {...props}><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>);
    case "sparkles":        return (<svg {...props}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8"/></svg>);
    case "chart":           return (<svg {...props}><path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>);
    case "users":           return (<svg {...props}><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><circle cx="17" cy="9" r="2.5"/><path d="M16 13c2.8 0 5 1.7 5 5"/></svg>);
    case "plate":           return (<svg {...props}><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5.5"/></svg>);
    case "leaf":            return (<svg {...props}><path d="M11 20A7 7 0 0 1 4 13c0-3 1-7 9-9 0 8-2 9-5 11"/><path d="M5 21c4-3 6-5 11-7"/></svg>);
    case "phone":           return (<svg {...props}><rect x="7" y="2" width="10" height="20" rx="2.5"/><path d="M11 18h2"/></svg>);
    case "globe":           return (<svg {...props}><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>);
    case "clock":           return (<svg {...props}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>);
    case "shield":          return (<svg {...props}><path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3z"/></svg>);
    case "bell":            return (<svg {...props}><path d="M6 16V11a6 6 0 0 1 12 0v5l1 2H5l1-2z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>);
    case "wand":            return (<svg {...props}><path d="m4 20 11-11"/><path d="M14 4l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z"/></svg>);
    case "card":            return (<svg {...props}><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18M7 15h4"/></svg>);
    case "message":         return (<svg {...props}><path d="M21 12a8 8 0 0 1-12 7l-5 1 1-4A8 8 0 1 1 21 12z"/></svg>);
    case "play":            return (<svg {...props}><path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/></svg>);
    case "chevron-down":    return (<svg {...props}><path d="m6 9 6 6 6-6"/></svg>);
    case "lang":            return (<svg {...props}><path d="M3 5h12M9 3v2M5 5c0 5 4 8 9 9M13 9c0 5-4 8-9 9"/><path d="m13 21 4-9 4 9M14.5 18h5"/></svg>);
    case "user":            return (<svg {...props}><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>);
    default: return null;
  }
};

export default Icon;
